<template>
  <section class="about container">
    <h2>{{ $t("home.about_title") }}</h2>
    <div class="about-content">
      <img class="about-img" src="@/assets/about.jpg" alt="About Us" />
      <p class="about-desc">{{ $t("home.about_desc") }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection"
};
</script>

<style scoped>
.about {
  max-width: 1200px;
  margin: 60px auto;
  padding: 20px;
}

.about h2 {
  font-size: 28px;
  margin-bottom: 24px;
  text-align: left;
}

.about-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 30px;
}

.about-img {
  width: 350px;
  height: 250px;
  object-fit: cover;
  border-radius: 12px;
  flex-shrink: 0;
}

.about-desc {
  flex: 1;
  line-height: 1.8;
  color: #444;
  white-space: pre-line;
  text-align: justify;
}

@media (max-width: 768px) {
  .about-content {
    flex-direction: column;
  }
  .about-img {
    width: 100%;
    height: auto;
  }
}
</style>
